export var AIR_CONDITIONING_FACILITY_CODES = ['ACO', 'HAC'];
export var FREE_PARKING_FACILITY_CODES = ['PAF', 'COC', 'COP', 'CPF', 'CPP'];
export var RESTAURANT_FACILITY_CODES = ['HRS', 'DIN', 'RES', 'ZFB'];
export var ACCESSIBLE_FACILITY_CODES = ['HAR'];
export var ACCEPTED_HOTEL_CARD_FACILITIES = [FREE_PARKING_FACILITY_CODES, RESTAURANT_FACILITY_CODES];